import React from 'react';

import {hasValue} from '@famly/stat_ts-utils_has-value';
import {FeatureSupportState} from 'web-app/util/graphql/api-types';
import {isEmptyString} from 'web-app/util/string';
import {useFetchFinanceFeaturesQuery} from 'web-app/react/bookings-finance/hooks/use-fetch-finance-features-query';

export const useCanAccessSimplifiedUSBillingPlan = (
    institutionSetId: string,
): {isSimplifiedUsBillingPlanEnabled: boolean; isSimplifiedUsEditBillingPlanEnabled: boolean; isLoading: boolean} => {
    const {data, loading} = useFetchFinanceFeaturesQuery({
        variables: {
            institutionSetId,
        },
        skip: !hasValue(institutionSetId) || isEmptyString(institutionSetId),
    });

    return React.useMemo(
        () => ({
            isSimplifiedUsBillingPlanEnabled:
                data?.finance.supports.canUseSimplifiedUsBillingPlan === FeatureSupportState.ACTIVE,
            isSimplifiedUsEditBillingPlanEnabled:
                data?.finance.supports.canUseSimplifiedUsEditBillingPlan === FeatureSupportState.ACTIVE,
            isLoading: loading,
        }),
        [
            data?.finance.supports.canUseSimplifiedUsBillingPlan,
            data?.finance.supports.canUseSimplifiedUsEditBillingPlan,
            loading,
        ],
    );
};
